import { render, staticRenderFns } from "./freightTemplateInpt.vue?vue&type=template&id=77d6b024&scoped=true"
import script from "./freightTemplateInpt.vue?vue&type=script&lang=js"
export * from "./freightTemplateInpt.vue?vue&type=script&lang=js"
import style0 from "./freightTemplateInpt.vue?vue&type=style&index=0&id=77d6b024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d6b024",
  null
  
)

export default component.exports